import { Component } from 'react';
import { connect } from 'react-redux';
import { deferFocus, getFirstFocusableElementSelectors } from '@mews-commander/utils';

interface WithAutoFocusProps {
    delay?: number;
    selector?: string | null;
}

const withAutoFocus =
    ({ delay, selector = null }: WithAutoFocusProps) =>
    (WrappedComponent: $TSFixMe) => {
        class AutoFocusedComponent extends Component {
            component: $TSFixMe;
            componentDidMount() {
                if (this.component) {
                    (this.props as $TSFixMe).deferFocus(this.component, {
                        delay: (this.props as $TSFixMe).delay ?? delay,
                        selector,
                        selectOnFocus: (this.props as $TSFixMe).selectOnFocus,
                    });
                }
            }

            componentRef = (c: $TSFixMe) => (this.component = c);

            render() {
                return <WrappedComponent {...this.props} ref={this.componentRef} />;
            }
        }
        return connect(undefined, { deferFocus })(AutoFocusedComponent);
    };

export const withAutoFocusingFirstFocusableElement = (props?: Pick<WithAutoFocusProps, 'delay'>) =>
    withAutoFocus({
        selector: getFirstFocusableElementSelectors(),
        ...props,
    });
